/**
 * MiniLineChart — pure SVG line + soft area fill.
 * Used for sales trend sparklines in stat cards and dashboard widgets.
 *
 * Usage:
 *   <MiniLineChart points={[12000, 18000, 15000, 21000, 28000, 24000, 32000]} />
 *   <MiniLineChart points={data} width={200} height={48} stroke="#1A4D2E" />
 */

export function MiniLineChart({
  points = [],
  width = 120,
  height = 40,
  stroke = 'var(--brand-primary)',
  fill = 'rgba(26,77,46,0.08)',
  strokeWidth = 1.5,
}) {
  if (!points || points.length < 2) return null;

  const min = Math.min(...points);
  const max = Math.max(...points);
  const range = max - min || 1;
  const padding = height * 0.1;

  const coords = points.map((p, i) => ({
    x: (i / (points.length - 1)) * width,
    y: height - padding - ((p - min) / range) * (height - padding * 2),
  }));

  const linePath = coords
    .map((c, i) => `${i === 0 ? 'M' : 'L'}${c.x.toFixed(2)},${c.y.toFixed(2)}`)
    .join(' ');

  const areaPath = `${linePath} L${width},${height} L0,${height} Z`;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      style={{ display: 'block' }}
    >
      <path d={areaPath} fill={fill} />
      <path
        d={linePath}
        fill="none"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* End dot */}
      <circle
        cx={coords[coords.length - 1].x}
        cy={coords[coords.length - 1].y}
        r="2.5"
        fill={stroke}
      />
    </svg>
  );
}
